import CustomSelect from "../../../common/interactive/CustomSelect";
import { useSelector, useDispatch } from "react-redux";
import { useMemo } from "react";
import classes from './ChangeAtty.module.css'
import { attorneyActions } from "../../../../store/attorneys";

export default function ChangeAtty({ activeCase: propActiveCase }) {
    const storeCase = useSelector(state => state.case.activeCase)
    const activeCase = propActiveCase ?? storeCase
    const dispatch = useDispatch()
    const options = useMemo(() => {
        if (!activeCase?.attorneys) {
            return []
        }
        return activeCase.attorneys.map(attorney => ({
            // label: attorney.law_firm?.name + ' '  + (attorney.ecm_unread_documents ? '- (unread documents) ' : '') + (attorney.ecm_unread_messages ? '- (unread messages)' : ''),
            label: attorney.law_firm?.name,
            complexLabel: `<span>${attorney.law_firm?.name}</span> <span class="unread-documents">${attorney.ecm_unread_documents ? '<i class="ti ti-file-check" style="color: var(--red);"></i>' : ''}</span> <span class="unread-messages">${attorney.ecm_unread_messages ? '<i class="ti ti-message" style="color: var(--red);"></i>' : ''}</span>`,
            value: attorney.id
        }))
    }, [activeCase])

    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)

    const managingAttorney = useMemo(() => {
        return activeCase?.attorneys?.find(attorney => attorney.is_managing_attorney)
    }, [activeCase])

    const onChangeHandler = (data) => {
        dispatch(attorneyActions.setSelectedProcoDocsAttorney(data.data.value))
    }

    if (!activeCase) {
        return null
    }

    return <div className={classes.container}>
        {/* thin_select={true} */}
        <CustomSelect optionsData={options} action={onChangeHandler} preSelectedValue={selectedProcoDocsAttorney ? selectedProcoDocsAttorney : managingAttorney?.id} label='Select Law Firm' complexLabel={true} />
    </div>
}
